import type { FC, ReactNode } from "react";

import { Field, FieldDescription, FieldError, FieldLabel } from "@recobra/ui/field";

export const FieldShell: FC<{
  label: string;
  id?: string;
  colSpan?: 1 | 2;
  required?: boolean;
  hint?: string;
  errorMessage?: string;
  children: ReactNode;
}> = ({ label, id, colSpan, required, hint, errorMessage, children }) => (
  <Field
    data-invalid={errorMessage ? "true" : undefined}
    className={colSpan === 2 ? "col-span-2" : "min-w-0"}
  >
    <FieldLabel htmlFor={id}>
      {label}
      {required && <span className="text-destructive">*</span>}
    </FieldLabel>
    {children}
    {hint ? <FieldDescription>{hint}</FieldDescription> : null}
    {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
  </Field>
);
